import { render, staticRenderFns } from "./mobileSignDialog.vue?vue&type=template&id=53cd6e8d&scoped=true"
import script from "./mobileSignDialog.vue?vue&type=script&lang=js"
export * from "./mobileSignDialog.vue?vue&type=script&lang=js"
import style0 from "./mobileSignDialog.vue?vue&type=style&index=0&id=53cd6e8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cd6e8d",
  null
  
)

export default component.exports